import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Joi from "joi-browser";
import { useState } from "react";
import { PlusIcon } from "@heroicons/react/20/solid";
import { message } from "antd";
import { addURLToKB, addWeblink } from "../service";
import { showErrorToast } from "V2.0/utils";

const template = [
  {
    name: "url",
    label: "Web Link *",
    type: "text",
  },
];

const schema = {
  url: Joi.string().uri().required().label("Web Link"),
};

function WeblinkForm(props) {
  const { open, setOpen, workspaceId, kbId, fetchKb } = props;

  const [loading, setLoading] = useState(false);
  const inputField = {
    url: "",
  };
  const { data, handleChange, validate, error, setError } = useForm(
    inputField,
    schema,
    false
  );

  const handleWeblinkSubmit = async () => {
    const errors = validate(data, schema);

    if (errors) {
      setError(errors);
      return;
    }

    setLoading(true);
    message.loading("Adding Weblink");

    try {
      const response = await addWeblink({ workspaceId, kbId, payload: data });
      if (response.status === 200) {
        message.destroy();
        setLoading(false);
        message.success("Weblink added");
        setOpen(false);
        fetchKb();
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to add web link");
    }
  };

  const isAddDisabled = Object.keys(error).length > 0;

  return (
    <Dialog size="xl" open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Add Weblink</DialogTitle>
      <DialogBody>
        <Form
          data={data}
          template={template}
          handleChange={handleChange}
          error={error}
        />
      </DialogBody>
      <DialogActions>
        <Button outline onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          onClick={handleWeblinkSubmit}
          loading={loading}
          disabled={isAddDisabled}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function WebLinkAdd(props) {
  const { workspaceId, kbId, fetchKb } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)} outline>
        <PlusIcon /> Add Web link
      </Button>
      {open && (
        <WeblinkForm
          open={open}
          setOpen={setOpen}
          workspaceId={workspaceId}
          kbId={kbId}
          fetchKb={fetchKb}
        />
      )}
    </>
  );
}

export default WebLinkAdd;
